import React from  'react';
import cbtManagement from '../../../../../apis/cbtManagement';
import { CONFIG } from '../../../../../config';
import ProfilCbtSearch from '../../../../../entity/ProfilCbtSearch';
import Loader from '../../../../Loader';
import __ from 'lodash';
import ProfilCbtOverview from './ProfilCbtOverview';

class ProfilCbtList extends React.Component{
    componentDidMount(){

    }

    componentDidUpdate(prevProps){
        
    }

    renderProfil(){
        console.log("sekolah dari cbt list :: ");
        console.log(this.props.sekolah);
        if(this.props.isLoading){
            return (
                <Loader />
            )
        }else{
            if(!__.isEmpty(this.props.profilCbt)){
                return this.props.profilCbt.map((profil) => {
                    return (
                        <div className="list-group-item list-group-item-action">
                            <div className="row">
                                <div className="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                                    <div className="d-flex w-100 justify-content-between">
                                        <h5 className="mb-1">{profil.namaProfil}</h5>
                                    </div>
                                    <small>{this.getKelas(profil.idKelas)} <br />{profil.jumlahPeserta} Peserta</small>
                                </div>
                                <div className="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                                    <ProfilCbtOverview showButton={true} totalPeserta={profil.jumlahPeserta} idProfil={profil.idProfilCbt} idSekolah={this.props.sekolah.idSekolah}/>
                                </div>
                            </div>
                        </div>
                    )
                })
            }else{
                
            }
        }
    }

    getKelas(idKelas){
        for (var i = 0; i < this.props.kelas.length; i++) {
            if(idKelas === this.props.kelas[i].idKelas){
                return this.props.kelas[i].namaKelas;
            }
        }
    }

    render(){
        return(
            <div>
                <div class="list-group">
                    {this.renderProfil()}
                </div>
            </div>
        )
    }
}

export default ProfilCbtList;